import { createContext, useContext } from "react";

export const BusinessContext = createContext({
  businesses: [],
  activeBusiness: null,
  setActiveBusiness: () => {},
  refreshBusinesses: async () => {},
});

export const useBusiness = () => useContext(BusinessContext);
